module.exports = __webpack_public_path__ + "501f725964edcac8a0ddb01a639563df.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/victorias_secret.png
// module id = 645
// module chunks = 0